import { createContext, useContext } from "react";

import type { useDeleteAccount } from "./use-delete-account";

type DeleteAccountContextValue = ReturnType<typeof useDeleteAccount>;

export const DeleteAccountContext = createContext<DeleteAccountContextValue | null>(null);

export function useDeleteAccountContext(): DeleteAccountContextValue {
  const context = useContext(DeleteAccountContext);
  if (!context)
    throw new Error("Delete account parts must be rendered inside <DeleteAccountProvider>");
  return context;
}
